import { useSetAtom, useAtomValue } from "jotai";
import {
  distributionCentersAtom,
  purchasersAtom,
  getPurchasersAtom,
  getDistributionCentersAtom,
  getValiditiesAtom,
  getPrioritiesAtom,
  validitiesAtom,
  prioritiesAtom,
  deductionTypesAtom,
  stagesAtom,
  getDeductionTypesAtom,
  getStagesAtom,
  glCodesAtom,
  getGLCodesAtom,
  retailersAtom,
  getRetailersAtom,
} from "@/store/lookup";
import {
  setDeductionDetailsAtom,
  clearDeductionDetailsAtom,
  patchDeductionDetailsAtom,
  setDeductionIntelligenceAtom,
  patchDeductionIntelligenceAtom,
  clearDeductionIntelligenceAtom,
  isDetailsUpdatingAtom,
  isIntelligenceUpdatingAtom,
  editModeAtom,
  setEditModeAtom,
} from "@/store/deduction/deduction";

export function useDeductionEdit() {
  const purchasers = useAtomValue(purchasersAtom);
  const distributionCenters = useAtomValue(distributionCentersAtom);
  const priorities = useAtomValue(prioritiesAtom);
  const validities = useAtomValue(validitiesAtom);
  const stages = useAtomValue(stagesAtom);
  const deductionTypes = useAtomValue(deductionTypesAtom);
  const glCodes = useAtomValue(glCodesAtom);
  const retailers = useAtomValue(retailersAtom);

  const editMode = useAtomValue(editModeAtom);
  const setEditMode = useSetAtom(setEditModeAtom);

  const isDeductionDetailsUpdating = useAtomValue(isDetailsUpdatingAtom);
  const isDeductionIntelligenceUpdating = useAtomValue(isIntelligenceUpdatingAtom);

  const getDistributionCenters = useSetAtom(getDistributionCentersAtom);
  const getPurchasers = useSetAtom(getPurchasersAtom);
  const getPriorities = useSetAtom(getPrioritiesAtom);
  const getValidities = useSetAtom(getValiditiesAtom);
  const getStages = useSetAtom(getStagesAtom);
  const getDeductionTypes = useSetAtom(getDeductionTypesAtom);
  const getGLCodes = useSetAtom(getGLCodesAtom);
  const getRetailers = useSetAtom(getRetailersAtom);
  
  const setDeductionDetails = useSetAtom(setDeductionDetailsAtom);
  const clearDeductionDetails = useSetAtom(clearDeductionDetailsAtom);
  const patchDeductionDetails = useSetAtom(patchDeductionDetailsAtom);

  const setDeductionIntelligence = useSetAtom(setDeductionIntelligenceAtom);
  const clearDeductionIntelligence = useSetAtom(clearDeductionIntelligenceAtom);
  const patchDeductionIntelligence = useSetAtom(patchDeductionIntelligenceAtom);

  return {
    // Lookups
    purchasers,
    distributionCenters,
    priorities,
    validities,
    stages,
    deductionTypes,
    glCodes,
    retailers,
    isDeductionDetailsUpdating,
    isDeductionIntelligenceUpdating,
    getDistributionCenters,
    getPurchasers,
    getPriorities,
    getValidities,
    getStages,
    getDeductionTypes,
    getGLCodes,
    getRetailers,
    // Deduction Details Actions
    setDeductionDetails,
    clearDeductionDetails,
    patchDeductionDetails,

    // Deduction Intelligence Actions
    setDeductionIntelligence,
    clearDeductionIntelligence,
    patchDeductionIntelligence,

    // Edit Mode
    editMode,
    setEditMode,
  };
}
